/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2023 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class chargehistory extends IceEntity {

  historyData: any = {};

  constructor(data: any) {
    super();
    this.resetHistoryData(data);
  }

  resetHistoryData(data?: any): void {
    if (data == null) data = {};
    this.historyData = data;
  }

  getHistoryData(): any {
    return this.historyData;
  }

  setService(key: string, svc: any) {
    if (key == null) return;
    this.historyData[key] = svc;
  }

  getService(key: string): any {
    if (key == null) return null;
    return this.historyData[key];
  }

  setServiceAmountDue(key: string, amt: number) {
    if (key == null) return;
    if (amt == null) amt = 0.0;

    this.historyData[key]["amountDue"] = amt;
  }

  getServiceAmountDue(key: string): number {
    if (key == null) return 0.0;
    return this.historyData[key]["amountDue"];
  }

  setServiceAssets(key: string, astData: any[]) {
    if (key == null) return;
    if (astData == null) astData = [];
    this.historyData[key][IceTypes.JournalType.jtAsset] = astData;
  }

  getServiceAssets(key: string): any[] {
    if (key == null) return;
    return this.historyData[key][IceTypes.JournalType.jtAsset];
  }

  setServiceExpenses(key: string, astData: any[]) {
    if (key == null) return;
    if (astData == null) astData = [];
    this.historyData[key][IceTypes.JournalType.jtExpense] = astData;
  }

  getServiceExpenses(key: string): any[] {
    if (key == null) return;
    return this.historyData[key][IceTypes.JournalType.jtExpense];
  }

  setServiceIncomes(key: string, astData: any[]) {
    if (key == null) return;
    if (astData == null) astData = [];
    this.historyData[key][IceTypes.JournalType.jtIncome] = astData;
  }

  getServiceIncomes(key: string): any[] {
    if (key == null) return;
    return this.historyData[key][IceTypes.JournalType.jtIncome];
  }

  setAllServicePostings(key: string, postings: any) {
    if (key == null) return;
    if (postings == null) postings = {};
    this.historyData[key][IceTypes.JournalType.jtPostings] = postings;
  }

  getAllServicePostings(key: string): any {
    if (key == null) return null;
    return this.historyData[key][IceTypes.JournalType.jtPostings];
  }

  setServicePosting(key: string, payKey: string, data: any): void {
    if (key == null) return;
    if (payKey == null) return;
    if (this.historyData[key] == null) return;
    if (this.historyData[key][IceTypes.JournalType.jtPostings] == null) this.historyData[key][IceTypes.JournalType.jtPostings] = {};
    this.historyData[key][IceTypes.JournalType.jtPostings][payKey] = data;
  }

  getServicePosting(key: string, payKey: string): any {
    if (key == null) return null;
    if (payKey == null) return null;
    if (this.historyData[key] == null) return null;
    if (this.historyData[key][IceTypes.JournalType.jtPostings] == null) return null;
    return this.historyData[key][IceTypes.JournalType.jtPostings][payKey];
  }

  setClaims(key: string, clmData: any[]) {
    if (key == null) return;
    if (clmData == null) clmData = [];
    this.historyData[key][IceTypes.JournalType.jtClaims] = clmData;
  }

  getClaims(key: string): any[] {
    if (key == null) return;
    return this.historyData[key][IceTypes.JournalType.jtClaims];
  }
}
